import React, { Component } from "react";
import { DragSource } from "react-dnd";
import { useTranslation } from "react-i18next";
import AddIcon from "@material-ui/icons/Add";
import _ from "lodash";
import { translateIncomeTreeData } from "../treeUtils";
import MiniRuleTree, { collectUnavailableBoxTypes, collectUnknownBoxTypes, countTreeNodes, getBoxCatalogEntry } from "./MiniRuleTree";

const nodeGeneralTypes = "GeneralNode"; //////////IMPORTANT

const generatedNodeSpec = {
    beginDrag: (componentProps) => ({ node: componentProps.buildIncomeNode() }),
};
const generatedNodeCollect = (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
});

class draggableGeneratedRootBase extends Component {
    render() {
        const { connectDragSource, isDragging, children } = this.props;
        return connectDragSource(
            <div className={"qia-artifact-root" + (isDragging ? " qia-artifact-root-dragging" : "")}>
                {children}
            </div>,
            { dropEffect: "copy" }
        );
    }
}

const DraggableGeneratedRoot = DragSource(
    nodeGeneralTypes,
    generatedNodeSpec,
    generatedNodeCollect
)(draggableGeneratedRootBase);


function mergeWithDefaults(defaults, provided) {
    let merged = _.cloneDeep(defaults || {});
    Object.entries(provided || {}).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
            merged[key] = value;
        } else if (!(key in merged)) {
            merged[key] = value;
        }
    });
    return merged;
}

function fillCatalogDefaults(node) {
    let catalogEntry = getBoxCatalogEntry(node.type);
    let filled = {
        ...node,
        properties: mergeWithDefaults(catalogEntry && catalogEntry.properties, node.properties)
    };
    if (catalogEntry && catalogEntry.metadata) {
        filled.metadata = mergeWithDefaults(catalogEntry.metadata, node.metadata);
    }
    if (node.children) {
        filled.children = node.children.map(fillCatalogDefaults);
    }
    return filled;
}


function RuleArtifactCard({ artifact, rulesContext, userVariablesAvailable, onInsertNodes }) {
    const { t } = useTranslation();

    let treeData = (artifact.rule && artifact.rule.tree_data) || [];
    let userVariables = (artifact.rule && artifact.rule.user_variables) || [];
    let unknownTypes = collectUnknownBoxTypes(treeData);
    let unavailableTypes = collectUnavailableBoxTypes(treeData, (rulesContext || {}).boxes);
    let unavailableNames = unavailableTypes.map((type) => {
        let catalogEntry = getBoxCatalogEntry(type);
        return catalogEntry && catalogEntry.description ? t(catalogEntry.description) : type;
    });
    let insertable = unknownTypes.length === 0 && unavailableTypes.length === 0;
    let nodeCount = countTreeNodes(treeData);


    const buildIncomeNodes = (outcomeNodes) =>
        translateIncomeTreeData(
            outcomeNodes.map(fillCatalogDefaults),
            rulesContext,
            userVariablesAvailable
        );

    const handleInsertAll = () => {
        if (!insertable) return;
        onInsertNodes(buildIncomeNodes(treeData));
    };

    return (
        <div className="qia-artifact-card">
            <div className="qia-artifact-header">
                <span className="qia-artifact-title">
                    {artifact.title || t("Trecho de regra gerado")}
                </span>
                <span className="qia-artifact-count">
                    {nodeCount + " " + (nodeCount === 1 ? t("nó") : t("nós"))}
                </span>
            </div>
            {insertable ? (
                <React.Fragment>
                    {treeData.map((rootNode, index) => (
                        <DraggableGeneratedRoot
                            key={index}
                            buildIncomeNode={() => buildIncomeNodes([rootNode])[0]}
                        >
                            <MiniRuleTree treeData={[rootNode]} />
                        </DraggableGeneratedRoot>
                    ))}
                    <div className="qia-artifact-footer">
                        <span className="qia-artifact-hint">{t("Arraste para a árvore ou")}</span>
                        <button type="button" className="qia-artifact-insert-btn" onClick={handleInsertAll}>
                            <AddIcon style={{ width: "14px", height: "14px" }} />
                            {t("Adicionar à regra")}
                        </button>
                    </div>
                    {userVariables.length > 0 && (
                        <div className="qia-artifact-variables">
                            {t("Variáveis necessárias:") + " " +
                                userVariables.map((variable) => variable.variable_name).join(", ")}
                        </div>
                    )}
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <MiniRuleTree treeData={treeData} />
                    {unknownTypes.length > 0 && (
                        <div className="qia-artifact-warning">
                            {t("Este trecho contém componentes desconhecidos e não pode ser inserido:") +
                                " " + unknownTypes.join(", ")}
                        </div>
                    )}
                    {unavailableTypes.length > 0 && (
                        <div className="qia-artifact-warning">
                            {t("Este trecho usa componentes que não estão disponíveis neste evento e não pode ser inserido:") +
                                " " + unavailableNames.join(", ")}
                        </div>
                    )}
                </React.Fragment>
            )}
        </div>
    );
}

export default RuleArtifactCard;
